import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from './toast';
import * as agentService from '../../services/agentService';
import * as agentOrdersService from '../../services/agentOrdersService';

class AgentCuttingModal extends Component {
   constructor(props) {
      super(props);
      this.state = {
         competitionName: '',
         eventName: '',
         marketType: "",
         marketName: "",
         marketId: "",
         isFancy: false,
         selectedAgent: "",
         selectedRunner:"",
         selectedOption:"",
         price: "",
         runner: "",
         amount: "",
         runners: [],
         agentsList:[],
         agentBetList:[],
         pageLimit: 25,
         pageActive: 1,
      };
   }
   async componentDidMount() {
      if(!!this.props.selectedMarket && !!this.props.selectedMarket.competition && !!this.props.selectedMarket.event)
      {
         this.setState({
            competitionName: this.props.selectedMarket.competition.name,
            eventName: this.props.selectedMarket.event.name,
            marketId: this.props.selectedMarket.marketId,
            marketType: this.props.selectedMarket.marketType,
            marketName: this.props.selectedMarket.marketName,
            isFancy: this.props.selectedMarket.bettingType === "LINE",
            runners: this.props.selectedMarket.bettingType === "LINE" ? [] : this.props.selectedMarket.runners
         },()=>{
            this.getAgentBetList();
         });
      }
      this.getAgentList();
   }
   getAgentList(){
      const self = this;
      agentService.getAgentsList().then((res) => {
         if (!!res) {
            self.setState(
               {
                  agentsList: []
               }, () => {
                  this.setState({
                  agentsList: res
                  });
               }
            );
         }
         else {
            this.setState({ agentsList: [] });
         }
      });
   }
   
   getAgentBetList(){
      agentOrdersService.getAgentBets(this.props.selectedMarket.event.id).then((res)=>{
         if (res.isSuccess) {
            for(let itm of res.items){
               itm.deleteIconDisable = false;
            }
            this.setState({ agentBetList: res.items });
         }
        else {
            this.setState({ agentBetList: [] });
        }
      });
   }

   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }
   onAction(e) {
      const name = e.target.name;
      const value = e.target.value;
      if (name === "page_no") {
         this.setState({ [name]: parseInt(value), last_id: "", action: "", first_id: "" }, () => { this.submitForm(); });
      }
      if (name === "last") {
         this.setState({ page_no: this.state.total_page, last_id: "", action: "", first_id: "" }, () => { this.submitForm(); });
      }
      else if (name === "prev" || name === "next" || name === "first") {
         this.setState({ action: name }, () => { this.submitForm(); });
      }
   }
   submitForm(){

   }

   resetForm() {
      this.setState({ 
         selectedAgent: "",
         selectedRunner:"",
         selectedOption:"",
         price: "",
         runner: "",
         amount: ""
      });
   }
   
   closePopup() {
      this.setState({ 
         competitionName: '',
         eventName: '',
         marketType: "",
         marketName: "",
         marketId: "",
         isFancy: false,
         selectedAgent: "",
         selectedRunner:"",
         selectedOption:"",
         price: "",
         runner: "",
         amount: "",
         runners: [],
         agentsList:[] 
      });
      this.props.closeAgentCuttingModal()
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }
   
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }
   onPagination() {
      let lst = []
      let total_page = this.state.total_page
      for (let x = 1; x <= total_page; x++) {
         if (this.state.page_no === x || Math.abs(x - this.state.page_no) <= 2 || (this.state.page_no < 3 && x < 6) || (total_page - this.state.page_no < 3 && total_page - x < 5)) {
            let htm = <button className={this.state.page_no === x ? "btn btn-blue active pagewidthpopup" : "btn btn-blue pagewidthpopup"} name="page_no" value={x} onClick={(e) => { this.onAction(e) }}>{x} </button>
            lst.push(htm)
         }
      }
      return lst
   }

   agentBetPlaceValidate(){
      return !!this.state.selectedAgent && !!this.state.selectedOption && !!this.state.price && !!this.state.amount && (this.state.isFancy ? !!this.state.runner : !!this.state.selectedRunner) ? false : true
   }
   
   agentPlaceBet(){
      const self = this;
      const body = {
         username: this.state.selectedAgent,
         marketId: this.state.marketId,
         amount: this.state.amount,
         side: this.state.selectedOption,
         runnerId: this.state.isFancy ? this.state.runner : this.state.selectedRunner,
         price: this.state.price,
         betStatus: "PLACED"
      };
      agentOrdersService.postAgentOrder(body).then((res) => {
         if (!!res && res.isSuccess) {
            this.getAgentBetList();
            self.resetForm();
            this.props.notify("Bet Placed Successfully", "success");
         }
         else {
            // this.setState({ agentsList: [] });
         }
      });
   }

   deleteAgentBet(id, deleteIconDisable)
   {
      // agentDeleteIcon_${agtbt._id}
      if(!deleteIconDisable){
         console.log(new Date().toISOString());
         let agentBetList = this.state.agentBetList;
         
         for(let itm of agentBetList){
            if(id === itm._id){
               itm.deleteIconDisable = true;
               break;
            }
         }
         this.setState({agentBetList: agentBetList}, ()=>{
            agentOrdersService.postAgentOrderDelete(id).then((res) => {
               if (!!res && res.isSuccess) {
                  this.getAgentBetList();
                  this.props.notify("Bet Deleted Successfully", "success");
               }
               else {
                  // this.setState({ agentsList: [] });
               }
            });
         })
         
      } else {

      }
   }
   render() {
      // let page_no = parseInt(this.state.page_no)
      // let count_records = parseInt(this.state.count_records)
      // let records_display = parseInt(this.state.records_display)
      // let current_record = 0
      // let total_record = 0
      // let start_record = 0
      // if (count_records > (records_display * page_no)) {
      //    current_record = records_display * page_no
      //    total_record = count_records
      //    start_record = current_record - (records_display - 1)
      // } else if (this.state.bets_data.length > 0) {
      //    current_record = count_records
      //    total_record = count_records
      //    start_record = ((page_no - 1) * records_display) + 1
      // }

      // let parent = "";
      // if (Object.keys(this.state.marketuserDetail).length > 0) {
      //    let usr = this.state.marketuserDetail
      //    for (let pat of usr.parents) {
      //       if (pat === this.state.accounts) {
      //          parent += pat
      //          break
      //       }
      //       else {
      //          parent += pat + " -> "
      //       }
      //    }
      // }
      // let competitionName = !!this.state.usermktData && !!this.state.usermktData.competitionName ? (this.state.usermktData.eventTypeId === '300' ? dateUtil.getBinaryCompetitionDisplayName(this.state.usermktData.competitionName) : this.state.usermktData.competitionName) : ""
      // let market_time = !!this.state.usermktData && this.state.usermktData.eventTypeId === '300' ? dateUtil.getBinaryMarketDisplayName(this.state.usermktData.marketName) : []
      return (
         <>
            <div className="modal fade show" style={{ display: 'block' }} id="eventunsettle" role="dialog" aria-modal="true">
               <div className="modal-dialog modal-lg modal-dialog-scrollable">
                  <div className="modal-content">
                     <div className="modal-header">
                        <h4 className="modal-title">{!this.props.isUserBet ? " Bet Place" : " View Bet"}</h4>
                        <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.closePopup() }}>×</button>
                     </div>
                     <div className="modal-body ac-state eventunsettledbets">                        
                        <>                          
                           <div className="market-analysis-user-market-details mb-3 eventunsettledbets">
                              <fieldset>
                                 <legend>Market Details:</legend>
                                 <ul className="row user-market-popup">
                                    <li className="w-50 mb-0"><label className="text-left">Competition :</label><span className="text-right">{this.state.competitionName}</span></li>
                                    <li className="w-50 mw100 mb-0">
                                       <label className="text-left">Event :</label><span className="text-right"><span className="">{this.state.eventName}</span></span>
                                    </li>                                  
                                 </ul>
                              </fieldset>
                           </div>
                        </>
                        <div className="market-analysis-user-market-details mb-3 eventunsettledbets">
                           <fieldset>
                              <legend>Bet Place:</legend>
                              <div className='row'>
                                 <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                                    <div className="form-group font-12">
                                       <label className="mb-0 pb-1 mt-1 agent-title">Select Agent</label>
                                       <select title="Agent" className="form-control" name="selectedAgent" value={this.state.selectedAgent} onChange={(e) => { this.onChange(e) }}>
                                          <option value="">Select Agent</option>
                                          {!!this.state.agentsList && this.state.agentsList.map((agt,x)=>{
                                             return(
                                                <option value={agt.name}>{agt.name}</option>
                                             )
                                          })}
                                       </select>
                                    </div>
                                 </div>
                              </div>
                              <div className='cutting-name'>Bet Place for <span className='cutting-highlight'>{this.state.marketName}</span></div>
                              <div className="row">
                           
                           { !this.state.isFancy &&
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    <label className="mb-0 pb-1 mt-1 agent-title cuttingfont-14">Select Runner</label>
                                    <select title="Runner" className="form-control" name="selectedRunner" value={this.state.selectedRunner} onChange={(e) => { this.onChange(e) }}>
                                       <option value="">Select Runner</option>
                                       {!!this.state.runners && this.state.runners.map((rnr, j)=>{
                                          return(
                                             <option value={rnr.id}>{rnr.name}</option>
                                          )
                                       })}
                                    </select>
                                 </div>
                              </div>
                           }
                           <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                              <div className="form-group font-12">
                                 <label className="mb-0 pb-1 mt-1 agent-title cuttingfont-14">Options</label>
                                 <select title="Option" className="form-control" name="selectedOption" value={this.state.selectedOption} onChange={(e) => { this.onChange(e) }}>
                                    <option value="">Select Options</option>       
                                    {this.state.isFancy ? 
                                    <>
                                       <option value="Lay">No</option>
                                       <option value="Back">Yes</option>
                                    </>
                                    :
                                    <>
                                       <option value="Back">Back</option>
                                       <option value="Lay">Lay</option>
                                    </>
                                    }
                                 </select>
                              </div>
                           </div>
                               
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    <label className="mb-0 pb-1 mt-1 agent-title cuttingfont-14">Price</label>
                                    <input className="form-control d-inline-block" value={this.state.price} name="price" onChange={(e) => { this.onChange(e) }} type="number" placeholder="Price" />
                                 </div>
                              </div>
                              {this.state.isFancy &&
                                 <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                    <div className="form-group font-12">
                                       <label className="mb-0 pb-1 mt-1 agent-title cuttingfont-14">Line</label>
                                       <input className="form-control  d-inline-block" value={this.state.runner} name="runner" onChange={(e) => { this.onChange(e) }} type="number" placeholder="Line" />
                                    </div>
                                 </div>
                              }
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    <label className="mb-0 pb-1 mt-1 agent-title cuttingfont-14" >Amount</label>
                                    <input className="form-control  d-inline-block" value={this.state.amount} name="amount" onChange={(e) => { this.onChange(e) }} type="number" placeholder="Amount" />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="btn-group mt-4" role="group" aria-label="Basic example" id="divpagecount">
                                    <button className="btn betplace btn-blue ml-1" disabled={this.agentBetPlaceValidate()} onClick={(e) => this.agentPlaceBet()}>Bet Place</button>
                                 </div>
                              </div>
                        </div>
                           </fieldset>
                           
                        </div>

                        

                        <div className="row">
                           <div className="col-12">
                              <div className="table-responsive">
                                 <table id="example" className="table table-bordered font-14 table-sm whitespace cuttingbg-white">
                                    <thead>
                                       <tr>
                                          <td>Market</td>
                                          <td>Runner</td>
                                          <td>Side</td>
                                          <td className="text-right fbold">Price</td>
                                          <td className="text-right fbold">Amount</td>
                                          <td>Agent Name</td>
                                          <td>Status</td>
                                          <td>Action</td>
                                       </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.agentBetList.map((agtbt, t)=>{
                                       return(
                                          
                                          <tr className={agtbt.side === 0 ? 'cuttinglay-back' : 'cuttinglay-lay'}>
                                             <td>{agtbt.marketName}</td>
                                             <td>{agtbt.runnerName}</td>
                                             <td>{agtbt.side === 0 ? (agtbt.marketBettingType === "LINE" ? "Yes" : "Back") : (agtbt.marketBettingType === "LINE" ? "No" : "Lay   ")}</td>
                                             <td className="text-right fbold">{agtbt.price}</td>
                                             <td className="text-right fbold">{agtbt.amount}</td>
                                             <td className=" fbold">{agtbt.username}</td>
                                             <td>{agtbt.betStatus}</td>
                                             <td>
                                                {agtbt.betStatus === "PLACED" &&
                                                   <i id={`agentDeleteIcon_${agtbt._id}`} class="fa fa-trash font-16-cutting text-red" aria-hidden="true" onClick={()=>this.deleteAgentBet(agtbt._id, agtbt.deleteIconDisable)}></i>
                                                }
                                             </td>
                                          </tr>
                                       )
                                    })}
                                       {/* <tr className='cuttinglay-lay'>
                                          <td>Match Odds</td>
                                          <td>-</td>
                                          <td>Back</td>
                                          <td className="text-right fbold">1.25</td>
                                          <td className="text-right fbold">-</td>
                                          <td className="text-right fbold">250000</td>
                                          <td className="text-right fbold">62500 </td>
                                          <td className=" fbold">Muko</td>
                                          <td>
                                             <i class="fa fa-edit font-16-cutting mr-2" aria-hidden="true"></i>
                                             <i class="fa fa-trash font-16-cutting text-red" aria-hidden="true"></i>
                                          </td>
                                       </tr>
                                       <tr className='cuttinglay-back'>
                                          <td>Match Odds</td>
                                          <td>-</td>
                                          <td>Back</td>
                                          <td className="text-right fbold">1.25</td>
                                          <td className="text-right fbold">-</td>
                                          <td className="text-right fbold">250000</td>
                                          <td className="text-right fbold">62500 </td>
                                          <td className=" fbold">Muko</td>
                                          <td>
                                             <i class="fa fa-edit font-16-cutting mr-2" aria-hidden="true"></i>
                                             <i class="fa fa-trash font-16-cutting text-red" aria-hidden="true"></i>
                                          </td>
                                       </tr> */}
                                    </tbody>
                                 </table>
                              </div>
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                 <div className="btn-group float-right" role="group" aria-label="Basic example" id="divpagecount">
                                    <button className="btn btn-blue ml-1 mb-2 "  data-dismiss="modal" onClick={() => { this.props.closeAgentCuttingModal() }}>Close</button>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                  </div>
               </div>
               <div className="modal-backdrop fade show" onClick={() => { this.closePopup() }}></div>
            </div>
         </>
      )
   }
}

function mapStateToProps(state) {
   return {
   };
}

function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(AgentCuttingModal);